/**
 * Product ID to Name Mapping
 * Centralized product information for tracking
 */

interface ProductInfo {
  id: number;
  slug: string;
  name: string;
}

export const PRODUCTS: Record<number, ProductInfo> = {
  1: { id: 1, slug: 'consultation', name: 'Consultation' },
  3: { id: 3, slug: 'full-allergy-test-consultation', name: 'Full Allergy Test + Consultation' },
  6: { id: 6, slug: 'full-allergy-test', name: 'Full Allergy Test' },
  8: { id: 8, slug: 'allergy-test-immunotherapy-plan', name: 'Allergy Test for Immunotherapy Plan' },
  9: { id: 9, slug: 'immunotherapy-plan-consultation', name: 'Immunotherapy Plan + Consultation' },
  10: { id: 10, slug: 'immunotherapy-treatment-3m', name: 'Immunotherapy Treatment 3 months' },
  12: { id: 12, slug: 'primary-allergy-test-consultation', name: 'Primary Allergy Test + Consultation' },
  13: { id: 13, slug: 'primary-allergy-test', name: 'Primary Allergy Test' },
  14: { id: 14, slug: 'immunotherapy-treatment-6m', name: 'Immunotherapy Treatment 6 months' },
  15: { id: 15, slug: 'primary-allergy-test-comment', name: 'Primary Allergy Test + Comment' },
  17: { id: 17, slug: 'food-intolerance-test', name: 'Food Intolerance Test' },
  18: { id: 18, slug: 'preventive-test', name: 'Preventive Test' },
  19: { id: 19, slug: 'allergychip-doctor-pro', name: 'AllergyChip Doctor Pro' },
  20: { id: 20, slug: 'food-intolerance-test-consultation', name: 'Food Intolerance Test + Consultation' },
  21: { id: 21, slug: 'repeated-consultation', name: 'Repeated Consultation' },
  22: { id: 22, slug: 'food-intolerance-test-selfco', name: 'Food Intolerance Test' },
  23: { id: 23, slug: 'molecular-allergy-test', name: 'Molecular Allergy Test' },
} as const;

export const getProductInfo = (productId: number): ProductInfo | null => {
  return PRODUCTS[productId] || null;
};

export const getProductName = (productId: number): string => {
  return PRODUCTS[productId]?.name || `Product ${productId}`;
};

export const getProductSlug = (productId: number): string => {
  return PRODUCTS[productId]?.slug || `product-${productId}`;
};
